// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DeleteButton_wrap__5EzuA","withLabel":"DeleteButton_withLabel__3_cHx","label":"DeleteButton_label__uJTxk"};